import React, {useState, useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import {TURNSTILE_SCRIPT_URL, CLOUDFLARE_TURNSTILE_SITE_KEY} from './constant'

const CloudflareTurnstileWidget = ({
  siteKey,
  onVerify,
  theme,
  size,
  action,
  className,
}) => {
  const widgetRef = useRef(null)
  const [widgetId, setWidgetId] = useState(null)
  const [isScriptLoaded, setIsScriptLoaded] = useState(false)
  const onVerifyRef = useRef(onVerify)

  useEffect(() => {
    onVerifyRef.current = onVerify
  }, [onVerify])

  useEffect(() => {
    if (window.turnstile) {
      setIsScriptLoaded(true)
      return
    }

    const setupScript = () => {
      const scriptId = 'cf-turnstile-script'
      if (document.getElementById(scriptId)) return

      window.onloadTurnstileCallback = () => {
        setIsScriptLoaded(true)
        delete window.onloadTurnstileCallback
      }

      const script = document.createElement('script')
      script.id = scriptId
      script.src = TURNSTILE_SCRIPT_URL
      script.async = true
      script.defer = true
      document.head.appendChild(script)
    }

    setupScript()
  }, [])

  useEffect(() => {
    if (!isScriptLoaded || !widgetRef.current || !window.turnstile) {
      return
    }

    if (!widgetId) {
      const newWidgetId = window.turnstile.render(widgetRef.current, {
        sitekey: siteKey || CLOUDFLARE_TURNSTILE_SITE_KEY,
        callback: (token) => onVerifyRef.current(token),
        theme,
        size,
        action,
      })
      setWidgetId(newWidgetId)
    }

    return () => {
      if (widgetId && window.turnstile) {
        try {
          window.turnstile.remove(widgetId)
        } catch (e) {}
        setWidgetId(null)
      }
    }
  }, [isScriptLoaded, siteKey, theme, size, action])

  return <div ref={widgetRef} className={className} />
}

CloudflareTurnstileWidget.propTypes = {
  siteKey: PropTypes.string,
  onVerify: PropTypes.func.isRequired,
  theme: PropTypes.oneOf(['light', 'dark', 'auto']),
  size: PropTypes.oneOf(['normal', 'compact', 'flexible']),
  action: PropTypes.string,
  className: PropTypes.string,
}

CloudflareTurnstileWidget.defaultProps = {
  theme: 'light',
  size: 'normal',
}

export default CloudflareTurnstileWidget
